'use strict';

(function () {

  // ── Utility ───────────────────────────────────────────────────

  function getUrlParam(name) {
    return new URLSearchParams(window.location.search).get(name);
  }

  // ── SKU matching (exact, case-insensitive, null-safe) ─────────

  function skuMatches(variantSku, sku) {
    var v = (variantSku || '').toLowerCase();
    var s = (sku || '').toLowerCase();
    if (!v || !s) return false;
    return v === s;
  }

  function findVariantBySku(variants, sku) {
    for (var i = 0; i < variants.length; i++) {
      if (skuMatches(variants[i].sku, sku)) return variants[i];
    }
    return null;
  }

  // Shown whenever the vehicle's fitment resolves to the universal rail SKU (ZTBUNV).
  var UNKNOWN_FITMENT_MESSAGE = "Your truck isn't in our database yet, but we are happy to build you a custom rail if we don't already stock one that fits. Place your order and a member of our team will reach out to confirm measurements with you before we ship.";

  function isUnknownFitment(fitment) {
    if (!fitment) return false;
    if (fitment.status === 'unknown_fitment') return true;
    return !!(window.YMM_UNIVERSAL_SKU && fitment.sku &&
      fitment.sku.toLowerCase() === window.YMM_UNIVERSAL_SKU.toLowerCase());
  }

  // ── Helper: Check if option fieldset is for Moto-Chok selection ───────

  function isMotoChokFieldset(fs) {
    if (!fs) return false;
    var handle = (fs.getAttribute('data-handle') || '').toLowerCase();
    if (handle.indexOf('moto-chok') !== -1 || handle.indexOf('chok') !== -1) {
      return true;
    }
    var label = fs.querySelector('.form__label');
    if (label && (label.textContent.toLowerCase().indexOf('moto-chok') !== -1 || label.textContent.toLowerCase().indexOf('chok') !== -1)) {
      return true;
    }
    return false;
  }

  // ── Custom Mount state ────────────────────────────────────────
  // toolbox-logic.js dispatches ymm:mount-changed when the customer picks
  // "Custom Mount" — while active, the fitment variant lock is bypassed
  // and the universal SKU is selected instead.

  var _customMountActive = false;
  document.addEventListener('ymm:mount-changed', function (e) {
    _customMountActive = !!(e.detail && e.detail.custom);
  });

  // ── PDP variant auto-lock ─────────────────────────────────────

  function lockVariantSelectsElement(variantSelects, fitment, vehicleLabel) {
    var variantDataEl = variantSelects.querySelector('[type="application/json"]');
    if (!variantDataEl) return false;

    var variants;
    try { variants = JSON.parse(variantDataEl.textContent); } catch (e) { return false; }

    // Try the vehicle's CSV SKU first, then the universal rail SKU —
    // covers CSV SKUs that no variant on this product carries.
    var target = findVariantBySku(variants, fitment.sku);
    if (!target && window.YMM_UNIVERSAL_SKU) {
      target = findVariantBySku(variants, window.YMM_UNIVERSAL_SKU);
    }

    if (!target) return false;

    var fieldsets = variantSelects.querySelectorAll('fieldset');
    if (target.options) {
      target.options.forEach(function (optionValue, index) {
        var fieldset = fieldsets[index];
        if (!fieldset) return;
        if (isMotoChokFieldset(fieldset)) return;
        var radio = fieldset.querySelector('input[type="radio"][value="' + optionValue.replace(/"/g, '\\"') + '"]');
        if (radio) {
          radio.checked = true;
        } else {
          var sel = fieldset.querySelector('select');
          if (sel) sel.value = optionValue;
        }
      });
      variantSelects.dispatchEvent(new Event('change', { bubbles: true }));
    }

    fieldsets.forEach(function (fs) {
      if (isMotoChokFieldset(fs)) return;

      fs.setAttribute('data-fitment-locked', 'true');
      fs.setAttribute('aria-disabled', 'true');

      // Mark unmatched radio buttons for CSS dimming/strikethrough
      fs.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        if (!radio.checked) {
          radio.setAttribute('data-fitment-unmatched', 'true');
        } else {
          radio.removeAttribute('data-fitment-unmatched');
        }
      });
    });

    var container = variantSelects.closest('.thb-product-detail');
    if (container) container.setAttribute('data-ymm-fitment', 'truck-matched');

    return true;
  }

  function applyVariantLock() {
    var variantSelectsEls = document.querySelectorAll('variant-selects');
    if (!variantSelectsEls.length) return;

    // Only run fitment messaging on Z-TRAK custom-fitment product pages.
    // The Liquid snippet sets data-fitment-messaging="true" on the main variant-selects for those products.
    var mainVariantSelects = null;
    for (var i = 0; i < variantSelectsEls.length; i++) {
      if (variantSelectsEls[i].dataset.fitmentMessaging === 'true') {
        mainVariantSelects = variantSelectsEls[i];
        break;
      }
    }
    if (!mainVariantSelects) {
      hideFitmentBanners();
      unlockVariants();
      return;
    }

    // Custom Mount bypasses the fitment lock — customer picks options freely.
    if (_customMountActive) {
      unlockVariants();
      hideFitmentBanners();
      return;
    }

    var mainSection = mainVariantSelects.dataset.section;

    var vehicle = window.FitmentStorage ? window.FitmentStorage.getVehicle() : null;

    // Fallback: if arriving from compatible-products with ?ymm_sku= in URL, use that SKU directly
    var urlSku = getUrlParam('ymm_sku');
    if (!vehicle && urlSku) {
      variantSelectsEls.forEach(function (vs) {
        if (vs.dataset.fitmentMessaging !== 'true') return;
        applyVariantLockBySku(vs, urlSku, null);
      });
      return;
    }

    if (!vehicle) { unlockVariants(); hideFitmentBanners(); return; }

    if (!window.YMMEngine || window.YMMEngine.state !== 'ready') return;

    var fitment = window.YMMEngine.lookup(vehicle.year, vehicle.make, vehicle.model);
    if (!fitment) { unlockVariants(); hideFitmentBanners(); return; }

    var vehicleLabel = vehicle.year + ' ' + vehicle.make + ' ' + vehicle.model;
    var needsReview = isUnknownFitment(fitment);

    // Check main product variant-selects for match to determine banner
    var mainHasMatch = lockVariantSelectsElement(mainVariantSelects, fitment, vehicleLabel);

    if (!mainHasMatch) {
      unlockVariants();
      showBanner('review', needsReview
        ? UNKNOWN_FITMENT_MESSAGE
        : 'Fitment for your ' + vehicleLabel + ' requires review. Once you place your order, our team will contact you to verify fitment details and confirm measurements before we ship.');
      return;
    }

    // Lock any additional variant-selects for the same product (e.g., sticky add-to-cart)
    for (var j = 0; j < variantSelectsEls.length; j++) {
      var vs = variantSelectsEls[j];
      if (vs === mainVariantSelects) continue;
      if (vs.dataset.fitmentMessaging !== 'true') continue;
      if (mainSection && vs.dataset.section !== mainSection) continue;
      lockVariantSelectsElement(vs, fitment, vehicleLabel);
    }

    if (needsReview) {
      showBanner('review', UNKNOWN_FITMENT_MESSAGE);
    } else {
      showBanner('guaranteed', 'Confirmed fit for your ' + vehicleLabel);
    }
  }

  function unlockVariants() {
    document.querySelectorAll('[data-fitment-locked="true"]').forEach(function (fs) {
      fs.removeAttribute('data-fitment-locked');
      fs.removeAttribute('aria-disabled');
    });
    document.querySelectorAll('[data-fitment-unmatched]').forEach(function (el) {
      el.removeAttribute('data-fitment-unmatched');
    });
    document.querySelectorAll('.thb-product-detail[data-ymm-fitment]').forEach(function (el) {
      el.removeAttribute('data-ymm-fitment');
    });
    // Also unlock small card selects
    document.querySelectorAll('product-card-small select[data-fitment-locked-select]').forEach(function (sel) {
      sel.disabled = false;
      sel.removeAttribute('data-fitment-locked-select');
      sel.removeAttribute('aria-disabled');
    });
  }

  function lockSmallCardVariants() {
    var vehicle = window.FitmentStorage ? window.FitmentStorage.getVehicle() : null;

    // If no vehicle, unlock everything
    if (!vehicle) {
      document.querySelectorAll('product-card-small select[data-fitment-locked-select]').forEach(function (sel) {
        sel.disabled = false;
        sel.removeAttribute('data-fitment-locked-select');
        sel.removeAttribute('aria-disabled');
      });
      return;
    }

    if (!window.YMMEngine || window.YMMEngine.state !== 'ready') return;

    var fitment = window.YMMEngine.lookup(vehicle.year, vehicle.make, vehicle.model);
    if (!fitment) return;

    var vehicleLabel = vehicle.year + ' ' + vehicle.make + ' ' + vehicle.model;

    document.querySelectorAll('product-card-small').forEach(function (card) {
      var handle = card.dataset.productHandle;
      if (!handle) return;
      if (!window.YMM_MANDATORY_HANDLES || window.YMM_MANDATORY_HANDLES.indexOf(handle) === -1) return;

      var selects = card.querySelectorAll('select');
      if (!selects.length) return;

      selects.forEach(function (sel) {
        sel.disabled = true;
        sel.setAttribute('data-fitment-locked-select', 'true');
        sel.setAttribute('aria-disabled', 'true');
      });
    });
  }

  function applyVariantLockBySku(variantSelects, sku, vehicleLabel) {
    var variantDataEl = variantSelects.querySelector('[type="application/json"]');
    if (!variantDataEl) return;
    var variants;
    try { variants = JSON.parse(variantDataEl.textContent); } catch (e) { return; }
    var target = findVariantBySku(variants, sku);
    if (!target && window.YMM_UNIVERSAL_SKU) {
      target = findVariantBySku(variants, window.YMM_UNIVERSAL_SKU);
    }
    if (!target) return;
    var fieldsets = variantSelects.querySelectorAll('fieldset');
    if (target.options) {
      target.options.forEach(function (optionValue, index) {
        var fieldset = fieldsets[index];
        if (!fieldset) return;
        if (isMotoChokFieldset(fieldset)) return;
        var radio = fieldset.querySelector('input[type="radio"][value="' + optionValue.replace(/"/g, '\\"') + '"]');
        if (radio) {
          radio.checked = true;
        } else {
          var sel = fieldset.querySelector('select');
          if (sel) sel.value = optionValue;
        }
      });
      variantSelects.dispatchEvent(new Event('change', { bubbles: true }));
    }
    fieldsets.forEach(function (fs) {
      if (isMotoChokFieldset(fs)) return;
      fs.setAttribute('data-fitment-locked', 'true');
      fs.setAttribute('aria-disabled', 'true');
    });
    var container = variantSelects.closest('.thb-product-detail');
    if (container) container.setAttribute('data-ymm-fitment', 'truck-matched');
    if (vehicleLabel) showBanner('guaranteed', 'Confirmed fit for your ' + vehicleLabel);
  }

  function showBanner(type, message) {
    hideFitmentBanners();
    var banner = document.getElementById('fitment-banner-' + type);
    if (!banner) return;
    var textEl = document.getElementById('fitment-banner-' + type + '-text');
    if (textEl) textEl.textContent = message;
    banner.removeAttribute('hidden');
    banner.classList.add('visible');

    // Sync fitment status hidden input for cart submission
    var statusMap = {
      'guaranteed': 'Confirmed Fitment',
      'review': 'Pending Review'
    };
    var statusInput = document.getElementById('fitment-prop-fitment-status');
    if (statusInput) {
      statusInput.value = statusMap[type] || '';
    }
  }

  function hideFitmentBanners() {
    ['guaranteed', 'review'].forEach(function (type) {
      var el = document.getElementById('fitment-banner-' + type);
      if (el) { el.setAttribute('hidden', ''); el.classList.remove('visible'); }
    });
    var statusInput = document.getElementById('fitment-prop-fitment-status');
    if (statusInput) statusInput.value = '';
  }

  // ── Collection grid fitment badges ───────────────────────────

  function applyCollectionBadges() {
    var vehicle = window.FitmentStorage ? window.FitmentStorage.getVehicle() : null;
    var hasEngine = window.YMMEngine && window.YMMEngine.state === 'ready';

    document.querySelectorAll('.badge--fitment, .badge--fitment-universal, .badge--fitment-review').forEach(function (b) { b.remove(); });

    document.querySelectorAll('product-card').forEach(function (card) {
      var handleEl = card.querySelector('[data-product-handle]');
      var handle = handleEl ? handleEl.dataset.productHandle : null;
      if (!handle) return;

      var badgesContainer = card.querySelector('.product-card--badges');
      if (!badgesContainer) return;

      var isMandatory = window.YMM_MANDATORY_HANDLES && window.YMM_MANDATORY_HANDLES.indexOf(handle) !== -1;
      var li = card.closest('li');
      var fitmentAttr = card.getAttribute('data-ymm-fitment') || (li ? li.getAttribute('data-ymm-fitment') : null);
      var compatibleAttr = card.getAttribute('data-ymm-compatible') || (li ? li.getAttribute('data-ymm-compatible') : null);

      if (!isMandatory) {
        // Universal product — always show Universal Fitment badge on compatible page (no engine needed)
        if (isCompatiblePage()) {
          var badge = document.createElement('span');
          badge.className = 'badge badge--fitment-universal';
          badge.textContent = 'Universal Fitment';
          badgesContainer.appendChild(badge);
        }
        return;
      }

      // Truck-specific product — requires engine to be ready and vehicle selected
      if (!hasEngine || !vehicle) return;
      var fitment = window.YMMEngine.lookup(vehicle.year, vehicle.make, vehicle.model);
      if (!fitment) return;

      if (compatibleAttr === 'true' || fitmentAttr === 'truck-matched') {
        var badge = document.createElement('span');
        badge.className = 'badge badge--fitment';
        badge.textContent = 'Truck-Specific Fitment';
        badgesContainer.appendChild(badge);
      }
      // Unmatched or unverified — no badge shown
    });
  }

  // ── Compatible-products collection filter ─────────────────────

  function isCompatiblePage() {
    var grid = document.getElementById('ProductGridContainer');
    return grid && grid.dataset.fitmentCollection;
  }

  function syncCompatibleUrl(sku) {
    if (!isCompatiblePage()) return;
    var url = new URL(window.location.href);
    if (sku) {
      url.searchParams.set('ymm_sku', sku);
    } else {
      url.searchParams.delete('ymm_sku');
    }
    history.replaceState(null, '', url.pathname + url.search);
  }

  function skeletonHTML() {
    return '<div class="ymm-skeleton-card">' +
      '<div class="ymm-skeleton-card__image"></div>' +
      '<div class="ymm-skeleton-card__body">' +
        '<div class="ymm-skeleton-card__line"></div>' +
        '<div class="ymm-skeleton-card__line ymm-skeleton-card__line--short"></div>' +
        '<div class="ymm-skeleton-card__line ymm-skeleton-card__line--price"></div>' +
      '</div></div>';
  }

  function filterCompatibleCollection() {
    if (!window.YMM_MANDATORY_HANDLES || !window.YMM_MANDATORY_HANDLES.length) return;

    var ymm_sku = getUrlParam('ymm_sku');

    // If no ymm_sku in URL but vehicle is saved, derive it and update URL
    if (!ymm_sku) {
      var vehicle = window.FitmentStorage ? window.FitmentStorage.getVehicle() : null;
      if (vehicle && window.YMMEngine && window.YMMEngine.state === 'ready') {
        var fitment = window.YMMEngine.lookup(vehicle.year, vehicle.make, vehicle.model);
        ymm_sku = fitment ? fitment.sku : null;
        if (isCompatiblePage()) syncCompatibleUrl(ymm_sku);
      }
    }

    if (!ymm_sku) {
      // No SKU available — if engine is ready, it means no vehicle is selected.
      // Reveal grid (remove skeleton state) so products show normally.
      if (isCompatiblePage() && window.YMMEngine && window.YMMEngine.state === 'ready') {
        var grid = document.getElementById('product-grid');
        if (grid) grid.classList.remove('ymm-filtering');
        var skeleton = document.getElementById('ymm-skeleton-overlay');
        if (skeleton) skeleton.classList.add('ymm-skeleton-overlay--hidden');
      }
      return;
    }

    var cards = document.querySelectorAll('product-card, product-card-small');
    var fetches = [];
    var _cardOriginals = {};

    // Reset previous filter states (compatible-page only)
    if (isCompatiblePage()) {
      document.querySelectorAll('#product-grid li[data-ymm-hidden]').forEach(function (li) {
        li.removeAttribute('data-ymm-hidden');
        li.style.display = '';
      });
    }
    document.querySelectorAll('product-card[data-ymm-compatible], product-card-small[data-ymm-compatible], #product-grid li[data-ymm-compatible]').forEach(function (el) {
      el.removeAttribute('data-ymm-compatible');
    });
    document.querySelectorAll('product-card[data-ymm-fitment], product-card-small[data-ymm-fitment], #product-grid li[data-ymm-fitment]').forEach(function (el) {
      el.removeAttribute('data-ymm-fitment');
    });

    cards.forEach(function (card) {
      var handleEl = card.querySelector('[data-product-handle]');
      var handle = handleEl ? handleEl.dataset.productHandle : null;
      if (!handle) return;

      var isMandatory = window.YMM_MANDATORY_HANDLES && window.YMM_MANDATORY_HANDLES.indexOf(handle) !== -1;
      var li = card.closest('li');

      if (!isMandatory) {
        // Universal product — mark immediately, no fetch needed
        card.setAttribute('data-ymm-compatible', 'universal');
        card.setAttribute('data-ymm-fitment', 'universal');
        if (li) {
          li.setAttribute('data-ymm-compatible', 'universal');
          li.setAttribute('data-ymm-fitment', 'universal');
        }
        return;
      }

      // Mandatory/truck-specific product — fetch variants to check SKU match
      if (isCompatiblePage()) {
        _cardOriginals[handle] = card.innerHTML;
        card.innerHTML = skeletonHTML();
      }

      fetches.push(
        fetch('/products/' + handle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (product) {
            if (isCompatiblePage() && _cardOriginals[handle]) card.innerHTML = _cardOriginals[handle];
            // Vehicle SKU first; universal rail SKU always counts as a
            // match so the universal product shows as matched even when
            // the CSV SKU exists nowhere in the store.
            var matched = findVariantBySku(product.variants, ymm_sku);
            var matchedSku = ymm_sku;
            if (!matched && window.YMM_UNIVERSAL_SKU) {
              matched = findVariantBySku(product.variants, window.YMM_UNIVERSAL_SKU);
              if (matched) matchedSku = window.YMM_UNIVERSAL_SKU;
            }
            if (!matched) {
              card.setAttribute('data-ymm-compatible', 'false');
              card.setAttribute('data-ymm-fitment', 'truck-unmatched');
              if (li) { li.setAttribute('data-ymm-compatible', 'false'); li.setAttribute('data-ymm-fitment', 'truck-unmatched'); }
            } else {
              if (isCompatiblePage()) rewriteCardLinks(card, handle, matchedSku, matched.id);
              card.setAttribute('data-ymm-compatible', 'true');
              card.setAttribute('data-ymm-fitment', 'truck-matched');
              if (li) { li.setAttribute('data-ymm-compatible', 'true'); li.setAttribute('data-ymm-fitment', 'truck-matched'); }
            }
          })
          .catch(function () {
            if (isCompatiblePage() && _cardOriginals[handle]) card.innerHTML = _cardOriginals[handle];
          })
      );
    });

    Promise.all(fetches).then(function () {
      if (isCompatiblePage()) {
        // Reorder within current page
        reorderCurrentPage();
      } else {
        // On other pages, just refresh badges
        applyCollectionBadges();
        applyPDPFitmentBadge();
      }
    });
  }

  function reorderCurrentPage() {
    var grid = document.getElementById('product-grid');
    if (grid) {
      var allLis = Array.from(grid.querySelectorAll(':scope > li'));
      var matched   = allLis.filter(function (li) { return li.getAttribute('data-ymm-fitment') === 'truck-matched'; });
      var universal = allLis.filter(function (li) { return li.getAttribute('data-ymm-fitment') === 'universal'; });
      var unmatched = allLis.filter(function (li) { return li.getAttribute('data-ymm-fitment') === 'truck-unmatched'; });
      var rest      = allLis.filter(function (li) { return !li.getAttribute('data-ymm-fitment'); });
      matched.concat(universal).concat(unmatched).concat(rest).forEach(function (li) { grid.appendChild(li); });
      grid.classList.remove('ymm-filtering');
    }
    var skeleton = document.getElementById('ymm-skeleton-overlay');
    if (skeleton) skeleton.classList.add('ymm-skeleton-overlay--hidden');

    // SEO: prevent indexing of filtered pages and clean canonical
    var robotsMeta = document.querySelector('meta[name="robots"]');
    if (!robotsMeta) {
      robotsMeta = document.createElement('meta');
      robotsMeta.name = 'robots';
      document.head.appendChild(robotsMeta);
    }
    robotsMeta.content = 'noindex, follow';
    var canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', window.location.origin + window.location.pathname);
    }

    applyCollectionBadges();
    applyPDPFitmentBadge();
  }

  function rewriteCardLinks(card, handle, ymm_sku, variantId) {
    card.querySelectorAll('a[href]').forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href || href.indexOf('/products/') === -1) return;
      var url = new URL(href, window.location.origin);
      if (variantId) {
        url.searchParams.set('variant', variantId);
      }
      url.searchParams.set('ymm_sku', ymm_sku);
      link.setAttribute('href', url.pathname + url.search);
    });
  }

  // ── Public API ────────────────────────────────────────────────

  window.FitmentFilter = {
    run: filterCompatibleCollection,
    applyVariantLock: applyVariantLock
  };

  // ── Event listeners ───────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', function () {
    if (window.YMMEngine && window.YMMEngine.state === 'ready') {
      applyVariantLock();
      applyCollectionBadges();
      filterCompatibleCollection();
    }
  });

  document.addEventListener('ymm:ready',    function () { applyVariantLock(); applyCollectionBadges(); filterCompatibleCollection(); });
  document.addEventListener('ymm:resolved', function () { applyVariantLock(); applyCollectionBadges(); filterCompatibleCollection(); });
  document.addEventListener('ymm:confirmed', function () {
    applyVariantLock();
    applyCollectionBadges();
    filterCompatibleCollection();
  });
  document.addEventListener('ymm:cleared', function () {
    applyVariantLock();
    applyCollectionBadges();
    if (isCompatiblePage()) syncCompatibleUrl(null);
    // Restore all hidden cards (compatible page only)
    document.querySelectorAll('#product-grid li[data-ymm-hidden]').forEach(function (li) {
      li.removeAttribute('data-ymm-hidden');
      li.style.display = '';
    });
    // Reveal grid and hide skeleton (compatible page only)
    var grid = document.getElementById('product-grid');
    if (grid) grid.classList.remove('ymm-filtering');
    var skeleton = document.getElementById('ymm-skeleton-overlay');
    if (skeleton) skeleton.classList.add('ymm-skeleton-overlay--hidden');
    // Re-run SKU verification to clear badges on all pages
    filterCompatibleCollection();
  });
  document.addEventListener('ymm:changed',  function () { applyVariantLock(); applyCollectionBadges(); });
  document.addEventListener('quick-view:open', function () {
    setTimeout(function () { applyVariantLock(); applyCollectionBadges(); applyPDPFitmentBadge(); }, 50);
  });

  // ── PDP + Small Card fitment badge ───────────────────────────

  function applyPDPFitmentBadge() {
    // Remove existing PDP/Quick View badges
    document.querySelectorAll('.fitment-pdp-badge').forEach(function (b) { b.remove(); });

    var vehicle = window.FitmentStorage ? window.FitmentStorage.getVehicle() : null;
    var fitment = null;
    var hasVehicle = vehicle && window.YMMEngine && window.YMMEngine.state === 'ready';
    if (hasVehicle) {
      fitment = window.YMMEngine.lookup(vehicle.year, vehicle.make, vehicle.model);
    }

    // Check all product contexts on page (PDP + any open Quick View)
    var variantSelectsEls = document.querySelectorAll('variant-selects');

    var processedSliders = new Set();

    variantSelectsEls.forEach(function (vs) {
      var container = vs.closest('.thb-product-detail');

      // Read handle from data-handle on .thb-product-detail (set in both main-product.liquid and main-product-quick-view.liquid)
      var handle = container ? container.dataset.handle : null;
      var fitmentAttr = container ? container.getAttribute('data-ymm-fitment') : null;
      if (!handle) return;

      // Find product-slider (main image) in this product's context
      var sliderEl = container ? container.querySelector('product-slider') : document.querySelector('product-slider');
      if (!sliderEl) return;

      // Prevent duplicate badges for the same slider
      if (processedSliders.has(sliderEl)) return;
      processedSliders.add(sliderEl);

      var isMandatory = window.YMM_MANDATORY_HANDLES && window.YMM_MANDATORY_HANDLES.indexOf(handle) !== -1;

      if (isMandatory) {
        // Truck-specific product — only show badge if applyVariantLock() confirmed a SKU match
        if (fitmentAttr === 'truck-matched') {
          var badge = document.createElement('span');
          badge.className = 'badge badge--fitment fitment-pdp-badge';
          badge.textContent = 'Truck-Specific Fitment';
          sliderEl.appendChild(badge);
        }
      } else if (isCompatiblePage()) {
        // Universal product on compatible page — show blue badge (no vehicle required)
        var badge = document.createElement('span');
        badge.className = 'badge badge--fitment-universal fitment-pdp-badge';
        badge.textContent = 'Universal Fitment';
        sliderEl.appendChild(badge);
      }
    });

    // Sticky add-to-cart badge — use same handle check as above
    var stickyTitle = document.querySelector('.product-add-to-cart-sticky--title');
    if (stickyTitle && !processedSliders.has(stickyTitle)) {
      var stickyContainer = document.querySelector('.thb-product-detail');
      var stickyHandle = stickyContainer ? stickyContainer.dataset.handle : null;
      var stickyFitmentAttr = stickyContainer ? stickyContainer.getAttribute('data-ymm-fitment') : null;
      if (stickyHandle) {
        var isStickyMandatory = window.YMM_MANDATORY_HANDLES && window.YMM_MANDATORY_HANDLES.indexOf(stickyHandle) !== -1;

        if (isStickyMandatory) {
          // Truck-specific — only show if applyVariantLock() confirmed a SKU match
          if (stickyFitmentAttr === 'truck-matched') {
            var stickyBadge = document.createElement('span');
            stickyBadge.className = 'badge badge--fitment fitment-pdp-badge';
            stickyBadge.textContent = 'Truck-Specific Fitment';
            stickyTitle.parentNode.insertBefore(stickyBadge, stickyTitle.nextSibling);
          }
        } else if (isCompatiblePage()) {
          // Universal product — show blue badge (no vehicle required)
          var stickyBadge = document.createElement('span');
          stickyBadge.className = 'badge badge--fitment-universal fitment-pdp-badge';
          stickyBadge.textContent = 'Universal Fitment';
          stickyTitle.parentNode.insertBefore(stickyBadge, stickyTitle.nextSibling);
        }
      }
    }

    // Small card badges — show Truck-Specific or Universal fitment badges
    document.querySelectorAll('product-card-small').forEach(function (card) {
      var handle = card.dataset.productHandle;
      if (!handle) return;

      var existing = card.querySelector('.badge--fitment, .badge--fitment-universal, .badge--fitment-review');
      if (existing) existing.remove();

      var isCardMandatory = window.YMM_MANDATORY_HANDLES && window.YMM_MANDATORY_HANDLES.indexOf(handle) !== -1;
      var li = card.closest('li');
      var fitmentAttr = card.getAttribute('data-ymm-fitment') || (li ? li.getAttribute('data-ymm-fitment') : null);
      var info = card.querySelector('.product-card-small--info');
      if (!info) return;

      if (isCardMandatory) {
        // Truck-specific product — show green badge if matched
        if (fitmentAttr === 'truck-matched') {
          var badge = document.createElement('span');
          badge.className = 'badge badge--fitment';
          badge.textContent = 'Truck-Specific Fitment';
          info.insertBefore(badge, info.firstElementChild);
        }
        // No badge for truck-unmatched
      } else if (isCompatiblePage()) {
        // Universal product on compatible page — show blue badge
        var badge = document.createElement('span');
        badge.className = 'badge badge--fitment-universal';
        badge.textContent = 'Universal Fitment';
        info.insertBefore(badge, info.firstElementChild);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', applyPDPFitmentBadge);
  document.addEventListener('ymm:ready', applyPDPFitmentBadge);
  document.addEventListener('ymm:resolved', applyPDPFitmentBadge);
  document.addEventListener('ymm:confirmed', applyPDPFitmentBadge);
  document.addEventListener('ymm:changed', applyPDPFitmentBadge);
  document.addEventListener('ymm:cleared', function () {
    document.querySelectorAll('.fitment-pdp-badge').forEach(function (b) { b.remove(); });
    document.querySelectorAll('.badge--fitment, .badge--fitment-universal, .badge--fitment-review').forEach(function (b) { b.remove(); });
  });

  // Apply fitment filtering and badges when infinite pagination loads new products
  document.addEventListener('pagination:page-changed', function () {
    var ymm_sku = getUrlParam('ymm_sku');
    if (!ymm_sku) return;

    var grid = document.getElementById('product-grid');
    if (!grid) return;

    // Find newly added product cards (those without data-ymm-fitment attribute)
    var newCards = grid.querySelectorAll('product-card:not([data-ymm-fitment])');
    if (newCards.length === 0) return;

    var fetches = [];

    newCards.forEach(function (card) {
      var handle = card.dataset.productHandle;
      if (!handle) return;

      var isMandatory = window.YMM_MANDATORY_HANDLES && window.YMM_MANDATORY_HANDLES.indexOf(handle) !== -1;
      var li = card.closest('li');

      if (!isMandatory) {
        // Universal product
        card.setAttribute('data-ymm-compatible', 'true');
        card.setAttribute('data-ymm-fitment', 'universal');
        if (li) {
          li.setAttribute('data-ymm-compatible', 'true');
          li.setAttribute('data-ymm-fitment', 'universal');
        }
      } else {
        // Mandatory product - check SKU match
        var fetch = fetch('/products/' + handle + '.js')
          .then(function (r) { return r.json(); })
          .then(function (product) {
            var matched = findVariantBySku(product.variants, ymm_sku);
            var matchedSku = ymm_sku;
            if (!matched && window.YMM_UNIVERSAL_SKU) {
              matched = findVariantBySku(product.variants, window.YMM_UNIVERSAL_SKU);
              if (matched) matchedSku = window.YMM_UNIVERSAL_SKU;
            }
            if (matched) {
              if (isCompatiblePage()) rewriteCardLinks(card, handle, matchedSku, matched.id);
              card.setAttribute('data-ymm-compatible', 'true');
              card.setAttribute('data-ymm-fitment', 'truck-matched');
              if (li) {
                li.setAttribute('data-ymm-compatible', 'true');
                li.setAttribute('data-ymm-fitment', 'truck-matched');
              }
            } else {
              card.setAttribute('data-ymm-compatible', 'false');
              card.setAttribute('data-ymm-fitment', 'truck-unmatched');
              if (li) {
                li.setAttribute('data-ymm-compatible', 'false');
                li.setAttribute('data-ymm-fitment', 'truck-unmatched');
              }
            }
          });
        fetches.push(fetch);
      }
    });

    Promise.all(fetches).then(function () {
      applyCollectionBadges();
      applyPDPFitmentBadge();
    });
  });

})();